import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/mleko/izracuni/laktacijaIzracuni";
const baseUrlPoKontroli = "/api/dog/mleko/izracuni/laktacijaPoKontroli";

export const fetchLaktacijaIzracuni = createAsyncThunk(
  "laktacijaIzracuni/fetch",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchLaktacijaPoKontroli = createAsyncThunk(
  "laktacijaIzracuni/fetchPoKontroli",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrlPoKontroli}/page`,
        undefined,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const thunks = [fetchLaktacijaIzracuni, fetchLaktacijaPoKontroli];

const initialState = {
  isLoading: false,
  page: { content: [] },
  pagePoKontroli: { content: [] },
  error: null,
};

const laktacijaIzracuniSlice = createSlice({
  name: "laktacijaIzracuni",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearPage: (state) => {
      state.page = { content: [] };
      state.pagePoKontroli = { content: [] };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLaktacijaIzracuni.fulfilled, (state, action) => {
        state.page = action.payload;
      })
      .addCase(fetchLaktacijaPoKontroli.fulfilled, (state, action) => {
        state.pagePoKontroli = action.payload;
      });

    handleLoadingAndErrorState(builder, thunks);
  },
});

export const { clearError, clearPage } = laktacijaIzracuniSlice.actions;

export default laktacijaIzracuniSlice.reducer;
